window.onscroll = function () {
    const menuShop = document.getElementById('nav-shop');
    const mainMenu = document.getElementById('nav-main');
    if (menuShop.getBoundingClientRect().top < 0 && !menuShop.classList.contains('fixed')) {
        menuShop.classList.add('fixed');
    }
    else if (mainMenu.getBoundingClientRect().top > -mainMenu.offsetHeight && menuShop.classList.contains('menu-close')) {
        menuShop.classList.remove('fixed');
    }
}

const menuSite = function() { 
    const menuClose = document.querySelector('#nav-shop .menu-icons .close');
    const menuOpen = document.querySelector('#nav-shop .menu-icons .open');
    const menu = document.getElementById('nav-shop');
    menuClose.addEventListener('click', function() {
        menu.classList.add('menu-close');
        menu.classList.remove('menu-open');
        menu.classList.remove('fixed');
    })
    menuOpen.addEventListener('click', function() {
        menu.classList.add('menu-open');
        menu.classList.remove('menu-close');
        menu.classList.add('fixed');
    })
}

addFunctionOnWindowLoad(menuSite);